// extracted by mini-css-extract-plugin
export default {"myClaimsTable":"MyClaimsTable_myClaimsTable__m0-eT","myClaimActions":"MyClaimsTable_myClaimActions__1WSgE","sortingIcon":"MyClaimsTable_sortingIcon__UrYzq"};